/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".breadcrumb-item[_ngcontent-%COMP%]   a[_ngcontent-%COMP%] {\n  text-decoration: underline; }\n\n.breadcrumb-arrow[_ngcontent-%COMP%]   .breadcrumb-item[_ngcontent-%COMP%]    + .breadcrumb-item[_ngcontent-%COMP%]::before {\n  content: \"/\";\n  color: #408080; }\n\n.no-decoration[_ngcontent-%COMP%] {\n  text-decoration: none; }"];
export { styles as styles };
